import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AuthorizedDriverModifyRequest } from "../shared/AuthorizedDriverModifyRequest";
import { DataService_AuthorizedDrivers } from "../shared/data.service";

@Component({
	selector: "app-edit-authorized-driver",
	templateUrl: "./edit-authorized-driver.component.html",
	styleUrls: ["./edit-authorized-driver.component.css"],
})
export class EditAuthorizedDriverComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AuthorizedDriversService: DataService_AuthorizedDrivers
	) {}

	ngOnInit(): void {
		this.DriverVerifyAuthID = this.dialogConfig.data.DriverVerifyAuthID;
		this.LicenseNbr = this.dialogConfig.data.LicenseNbr;
		this.DriverName = this.dialogConfig.data.DriverName;
		this.Active = this.dialogConfig.data.Active;
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////
	DriverVerifyAuthID: any = -1;
	LicenseNbr: any = "";
	DriverName: any = "";
	Active: any = 1;

	errorMessage: any = "";

	Processing: any = false;
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//
		// Error handling
		//
		if (this.LicenseNbr == "") {
			this.errorMessage = "Enter a license number";
			return;
		}

		//
		// Call SP
		//

		this.Processing = true;

		this.LicenseNbr = this.ReplaceAll(this.LicenseNbr, "-", "");
		this.LicenseNbr = this.ReplaceAll(this.LicenseNbr, "_", "");
		this.LicenseNbr = this.ReplaceAll(this.LicenseNbr, " ", "");
		this.LicenseNbr = String(this.LicenseNbr).toUpperCase();

		let parms: AuthorizedDriverModifyRequest = {
			DriverVerifyAuthID: this.DriverVerifyAuthID,
			LicenseNbr: this.LicenseNbr,
			DriverName: this.DriverName,
			Active: this.Active,
		};

		var result = this.AuthorizedDriversService.AuthorizedDriverModify(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Driver was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Driver",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////

	ReplaceAll(OriginalString: string, ToFind: string, ReplaceWith: string) {
		// Go through all instances
		while (OriginalString.indexOf(ToFind) != -1) {
			OriginalString = OriginalString.replace(ToFind, ReplaceWith);
		}

		return OriginalString;
	}

	//////////////////////////////////////////////////////////////
}
